import React from 'react';
import { Fit, LongText, Text, fs } from '../parts/fields';
import { Logo, useFieldSize } from '../parts/chrome';
import { str, useSlide } from '../parts/context';

// #region StatementLayout
/** One big idea: a large statement with an optional paragraph under it. */
export const StatementLayout: React.FunctionComponent = (): React.ReactElement => {
    const { slide, edit } = useSlide();
    const size = useFieldSize('title', [[36, 120], [64, 100], [96, 86], [999, 74]]);
    const bodySize = useFieldSize('body', [[160, 38], [320, 34], [480, 30], [999, 27]]);
    const hasBody = edit || !!str(slide.fields.body).trim();
    return (
        <>
            <div aria-hidden="true" style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 18, background: 'var(--wd-frame)' }} />
            <div className="wd-pad" style={{ paddingLeft: 160 }}>
                <Fit style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <Text k="eyebrow" className="wd-eyebrow" placeholder="Eyebrow" max={40} style={{ fontSize: fs(22) }} />
                    <Text k="title" as="h2" className="wd-h" style={{ fontSize: fs(size), maxWidth: 1500 }} placeholder="Your statement" max={120} />
                    {hasBody ? (
                        <>
                            <div className="wd-rule" style={{ margin: '56px 0 48px' }} />
                            <LongText k="body" className="wd-lead" style={{ fontSize: fs(bodySize), maxWidth: 1240 }} placeholder="Add a short paragraph (optional)" max={600} />
                        </>
                    ) : null}
                </Fit>
            </div>
            <Logo style={{ left: 160 }} />
        </>
    );
};
